import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';

export const needCustomJudgeShoppingCartPlanInit = () => {
  if ([flowTypes.edit].includes(pageConfig?.type)) {
    return [planTypes.ZOOM_PHONE].includes(window.$context.type);
  }

  return false;
}
